// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/angular2-busy/build/style/busy.css
// module id = ./node_modules/angular2-busy/build/style/busy.css
// module chunks = 4